import { createDCHook, createMutationHook, collapseDataFromCall, collapseParams } from '../client';
import { getReading, saveReading, downloadReadings, getReadingSummary } from '../services/ReadingService';

export const useReadingGetReading = createDCHook('getReading', collapseDataFromCall(getReading), {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: true,
});

export const useReadingSaveReading = createMutationHook(
  collapseDataFromCall(
    collapseParams(collapseParams(saveReading, 'requestBody', 'data'), 'data', 'readingId', 'houseNumber', 'meters'),
  ),
  {
    injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
    flattenData: true,
    flattenBodyPairs: [
      { target: 'requestBody', props: ['data'] },
      { target: 'data', props: ['readingId', 'houseNumber', 'meters'] },
    ],
  },
);

export const useReadingDownloadReadings = createDCHook('downloadReadings', downloadReadings, {
  injectables: ['label', 'customerId', 'accountId', 'businessUnit'],
  flattenData: false,
});

export const useReadingGetReadingSummary = createDCHook(
  'getReadingSummary',
  collapseDataFromCall(getReadingSummary),
  { injectables: ['label', 'customerId', 'businessUnit'], flattenData: true },
  { maxAge: 15000 },
);
